<app-loading-screen></app-loading-screen>
<app-expired-login-dialog></app-expired-login-dialog>
<div>
  <router-outlet></router-outlet>
</div>

